import React from "react";
import { useTranslation } from "react-i18next";
import BreadCrumb from "components/breadcrumb";
import MainHeader from "components/header";
import AffiliateDashBoard from "components/main/dashboard";

const DashBoard = () => {
  const {t, i18n} = useTranslation('common');
  const nav = [
    {
      url: "/affiliate/overview",
      label: t("general.dashboard"),
      main: true,
    },
  ];
  return (
    <>
      <MainHeader title={t("general.dashboard")}/>
      <BreadCrumb links={nav} />
      <AffiliateDashBoard />
    </>
  );
};

export default DashBoard;
